import { useNode } from '@craftjs/core';
import {
	SliderControl,
	SwitchControl,
	TextControl
} from 'pages/PageEditor/settingsComponents';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { sizeOptions } from './editorInputConstants';

type Props = {
	// eslint-disable-next-line react/require-default-props
	children?: JSX.Element | JSX.Element[];
};

const EditorInputSettings = ({ children }: Props) => {
	const {
		placeholder,
		size,
		label,
		fullWidth,
		required,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [
		onPlaceholderChange,
		onLabelChange,
		onSizeChange,
		onFullWidthChange,
		onRequiredChange
	] = useMemo(
		() =>
			['placeholder', 'label', 'size', 'fullWidth', 'required'].map((attr) =>
				generateOnChange(setProp, attr)
			),
		[setProp]
	);

	return (
		<Box display="flex" flexDirection="column">
			<TextControl
				value={label}
				label={intl.tr('screenEditor.settings.input.label')}
				setValue={onLabelChange}
				order={10}
			/>

			<TextControl
				value={placeholder}
				label={intl.tr('screenEditor.settings.input.placeholder')}
				setValue={onPlaceholderChange}
				order={20}
			/>

			<SliderControl
				label={intl.tr('screenEditor.settings.input.size')}
				value={size}
				options={sizeOptions}
				setValue={onSizeChange}
				marks
				order={30}
			/>

			<SwitchControl
				value={fullWidth}
				label={intl.tr('screenEditor.settings.fullWidth')}
				setValue={onFullWidthChange}
				order={40}
			/>

			<SwitchControl
				value={required}
				label={intl.tr('screenEditor.settings.input.required')}
				setValue={onRequiredChange}
				order={50}
			/>

			{children}
		</Box>
	);
};

export { EditorInputSettings };
